export default __webpack_public_path__ + "static/media/urlShortner.d07944e0.png";